import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Icone } from "@/components/Icone";

/**
 * Relê do servidor.
 *
 * Não é um "carregar" disfarçado: a tela já chegou pronta. Isto existe para
 * a agenda, que vive no Google e pode ter mudado por fora — alguém remarcou
 * pelo celular, e a tela ainda mostra o de antes. Marca como velho o que está
 * guardado; a tela na frente é buscada de novo e trocada quando chega.
 */
export function BotaoAtualizar({ rotulo = "Atualizar" }: { rotulo?: string }) {
  const cache = useQueryClient();
  const [pendente, setPendente] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        setPendente(true);
        void cache.invalidateQueries().finally(() => setPendente(false));
      }}
      disabled={pendente}
      className="flex h-9 items-center gap-1.5 rounded-full bg-[var(--color-cartao)] px-4 text-[13px] font-semibold text-[var(--color-tinta)] shadow-botao transition-colors hover:bg-[var(--color-painel)] disabled:opacity-50"
    >
      <Icone nome="reabrir" className={`h-4 w-4 ${pendente ? "animate-spin" : ""}`} />
      {rotulo}
    </button>
  );
}
